module.exports = __webpack_public_path__ + "img/business_8.3fab972e.jpg";